import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-wrong-resident',
  standalone: true,
  imports: [],
  templateUrl: './wrong-resident.component.html',
  styleUrl: './wrong-resident.component.scss',
})
export class WrongResidentComponent {
  modal = inject(BsModalRef);
}
